import React, { Component } from "react";
import { withStyles } 		from "material-ui/styles";
import TextField 			from "material-ui/TextField";
import Paper 				from "material-ui/Paper";
import Typography 			from "material-ui/Typography";
import Button 				from "material-ui/Button";
import Snackbar 			from "material-ui/Snackbar";
import IconButton 			from 'material-ui/IconButton';
import Input, {
	InputLabel,
	InputAdornment } 		from 'material-ui/Input';
import {
	FormControl,
	FormHelperText } 		from 'material-ui/Form';
import Visibility 			from 'material-ui-icons/Visibility';
import VisibilityOff 		from 'material-ui-icons/VisibilityOff';
import logo 				from "./../static/img/logo.png";

const styles = {
  Login: {
    display: "flex",
    justifyContent: "center",
    padding: "0 4em",
    backgroundColor: "#EEEEEE",
    minHeight: "100vh"
  },
  paper: {
    marginTop: "50px",
    marginBottom: "50px",
    padding: "2em",
    maxHeight: "330px"
  },
  logo: {
    height: "40px",
    justifyContent: "center"
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  button: {
    marginTop: "30px"
  },
  textField: {
    width: "100%"
  }
};

class Login extends Component {
  classes = this.props.classes;
  state = {
    error: false
  };

  constructor(props) {
    super(props);

	this.state = {
		'auth' : {
			'email' : '',
			'password' : '',
		},
		'showPassword' : false
	}

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClickShowPassword = () => {
	  this.setState({'showPassword' : !this.state.showPassword})
  }

  handleInputChange = e => {
	  let state = this.state.auth;
	  state[e.target.name] = e.target.value;
	  this.setState(state)
  }

  onSubmit = () => {
	  const {
		  email,
		  password
	  } = this.state.auth
	  this.props.logIn(email, password);
  }


  render() {
    return (
      <div className={this.classes.Login}>
        <Paper className={`align-center ${this.classes.paper}`}>
          <img alt="Logo" className={this.classes.logo} src={logo} />
          <div className="align-center">
			<div className="input-wrap">
				<TextField
					id="email"
					label="Email"
					name="email"
					value={this.state.auth.name}
					onInput={this.handleInputChange}
					margin="normal"
					fullWidth
				/>
			</div>
			<div className="input-wrap">
				<FormControl>
					<InputLabel htmlFor="adornment-password">Password</InputLabel>
					<Input
					  id="adornment-password"
					  name="password"
					  type={this.state.showPassword ? 'text' : 'password'}
					  value={this.state.auth.password}
					  onInput={this.handleInputChange}
					  endAdornment={
						<InputAdornment position="end">
						  <IconButton
							aria-label="Toggle password visibility"
							onClick={this.handleClickShowPassword}
							onMouseDown={this.handleMouseDownPassword}
						  >
							{this.state.showPassword ? <VisibilityOff /> : <Visibility />}
						  </IconButton>
						</InputAdornment>
					  }
					/>
				</FormControl>
			</div>
			<Button
			    color="primary"
			    className={this.classes.button}
			    variant="raised"
				onClick={this.onSubmit}
			>
			  Login
			</Button>
			<p>
				Don't have an account? &nbsp;
				<a href="/register">Sign Up</a>
			</p>
          </div>
        </Paper>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          open={this.props.account.error}
          message={<span id="message-id">{this.props.account.errorMsg}</span>}
        />
      </div>
    );
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };
  handleSubmit = event => {
    event.preventDefault();
    this.props.logIn();
  };
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js